import * as React from 'react';
import { useDataGridBodyStyles_unstable } from './useDataGridBodyStyles.styles';
import { useDataGridBody_unstable } from './useDataGridBody';
import { renderDataGridBody_unstable } from './renderDataGridBody';
/**
 * @deprecated - please use [\@fluentui-contrib/react-data-grid-react-window](https://www.npmjs.com/package/\@fluentui-contrib/react-data-grid-react-window) instead
 */ export const DataGridBody = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useDataGridBody_unstable(props, ref);
    useDataGridBodyStyles_unstable(state);
    return renderDataGridBody_unstable(state);
});
// eslint-disable-next-line deprecation/deprecation
DataGridBody.displayName = 'DataGridBody';
